import { FC, useEffect } from 'react'

interface ExternalRedirectProps {
  url: string
}

export const ExternalRedirect: FC<ExternalRedirectProps> = ({ url }) => {
  useEffect(() => {
    window.location.assign(url)
  }, [url])

  return <></>
}
